// src/components/TermsOfService.js
import React from "react";

const TermsOfService = () => {
  return (
    <div style={{ padding: "20px", maxWidth: "800px", margin: "0 auto", fontFamily: "Arial, sans-serif" }}>
      <h1>OkGather Terms of Service</h1>
      <p><strong>Effective Date:</strong> January 1, 2025</p>
      <p><strong>Company Address:</strong> 128 City Road, London, United Kingdom, EC1V 2NX</p>
      <h2>1. Introduction</h2>
      <p>
        Welcome to OkGather. These Terms of Service govern your use of our website and services.
        By accessing or using our services, you agree to be bound by these terms. If you do not agree
        to these terms, please do not use our services.
      </p>
      <h2>2. Eligibility</h2>
      <p>
        Our services are available only to individuals who are at least 18 years old and are capable of
        forming legally binding contracts. By using our services, you represent and warrant that you meet
        these eligibility requirements.
      </p>
      <h2>3. User Accounts</h2>
      <p>
        When you create an account with OkGather, you agree to provide accurate and complete information.
        You are responsible for safeguarding your account and password and for any activities that occur
        under your account.
      </p>
      <h2>4. Acceptable Use</h2>
      <p>
        You agree not to use our services for any unlawful, harmful, or fraudulent purposes. You
        further agree not to disrupt or interfere with our services or servers.
      </p>
      <h2>5. Intellectual Property</h2>
      <p>
        All content provided by OkGather, including text, graphics, logos, and software, is the property
        of OkGather or its licensors and is protected by intellectual property laws.
      </p>
      <h2>6. Disclaimer of Warranties</h2>
      <p>
        Our services are provided "as is" and "as available" without any warranty of any kind, either express
        or implied. OkGather does not warrant that the services will be uninterrupted, error-free, or secure.
      </p>
      <h2>7. Limitation of Liability</h2>
      <p>
        In no event shall OkGather, its directors, employees, or affiliates be liable for any indirect,
        incidental, special, consequential, or punitive damages arising out of your use of our services. By attending any gathering / event you agree that OkGather 
        will not be responsible in any way for what happens at the gathering or any costs/expenses related to the gathering such as those relating to food, drinks or any other costs.
      </p>
      <h2>8. Governing Law</h2>
      <p>
        These Terms of Service shall be governed by and construed in accordance with the laws of the United Kingdom.
      </p>
      <h2>9. Changes to These Terms</h2>
      <p>
        We reserve the right to modify these Terms at any time. Changes will be posted on this page and become effective immediately upon posting.
      </p>
      <h2>10. Contact Information</h2>
      <p>
        If you have any questions about these Terms, please contact us at info@okgather.com.
      </p>
    </div>
  );
};

export default TermsOfService;
